module.exports = __webpack_public_path__ + "img/a628344.png";